import { jsx as _jsx } from "react/jsx-runtime";
import { useTestId } from "@/hooks";
import { FeedbackMessage } from "@gemini/ui";
import { useContactContext } from "@/contexts/contact";
import { useI18n, useIsNewBuildProject } from "@/shared/hooks";
export const DescriptionCTA = () => {
    const { toggleModal } = useContactContext();
    const testId = useTestId("Sections.Description.CTA");
    const isProject = useIsNewBuildProject();
    const { t } = useI18n();
    const btnText = isProject
        ? t("contact.form.project.email")
        : t("description.fallback.cta");
    return (_jsx(FeedbackMessage, { testId: `${testId}`, variant: "info", startButtonProps: {
            children: btnText,
            onPress: () => {
                toggleModal({
                    av_zone: "description_notavailable",
                    legacyTrackingInfos: "detail-bottom",
                });
            },
        }, children: t("description.fallback.text") }));
};
